<template>
  <b-modal
    v-model="show"
    title="Create New Template"
    centered
    hide-footer
    @hidden="reset"
  >
    <div class="mb-1">
      <label class="font-weight-bold">Base Template</label>
      <b-form-input :value="baseTemplate" readonly />
    </div>
    <div class="mb-2">
      <label class="font-weight-bold">Custom Template Name</label>
      <b-form-input
        v-model="customName"
        placeholder="Enter custom name..."
        autofocus
      />
    </div>
    <div class="d-flex justify-content-end" style="gap: 8px">
      <b-button variant="secondary" @click="show = false">Cancel</b-button>
      <b-button variant="primary" :disabled="!customName.trim()" @click="handleCreate">
        Create Template
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BFormInput, BButton } from "bootstrap-vue";

export default {
  name: "CreateTemplateModal",
  components: { BModal, BFormInput, BButton },
  props: {
    value: { type: Boolean, default: false },
    baseTemplate: { type: String, default: "" },
  },
  data() {
    return {
      customName: "",
    };
  },
  computed: {
    show: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
  },
  methods: {
    handleCreate() {
      this.$emit("create", {
        baseTemplate: this.baseTemplate,
        name: this.customName.trim(),
      });
      this.show = false;
    },
    reset() {
      this.customName = "";
    },
  },
};
</script>
